import React, { FC } from 'react';

import projectConfig, { PROJECT } from '~/projects/config';

const ThemeToggle =
  projectConfig.project === PROJECT.POLYLLM_CHAT
    ? require('~/projects/polyllm-chat/components/ThemeToggle').default
    : null;

const ThemeToggleLoader: FC = () => {
  if (!ThemeToggle) return null;
  return <ThemeToggle />;
};

export default ThemeToggleLoader;
